import React, { useEffect, useState } from "react"; // Se mantiene React y hooks básicos
import { useSelector } from "react-redux";
import auth from "../../Helpers/auth";

import Footer from "../Footer/Footer.components";
import CabezoteComponent from "../Cabezote/cabezote.component";
import { useCounter } from "../../Helpers/useCounter";
import Steep1 from "./steep1";
import Second from "./Second.component";
import MetodosPago from "./metodoPago.component";
import * as constant from "../../global/const";
import axios from "axios";
import { TransparentLoader } from "../Loader/transparentLoader.component";
import ModalNotificacion from "../Cabezote/Notificacion/modalNotificacion.component";

const Checkout = ({ history }) => {
  const sucursal = useSelector((state) => state.page.sucursal);
  const carritoRedux = useSelector((state) => state.carrito.carrito);
  let carritoPromosRedux = useSelector(
    (state) => state.carritoPromo.carritoPromos
  );
  const [canTakeOrder, setCanTakeOrder] = useState(true);

  const [mostrarOpciones, setMostrarOpciones] = useState(false);

  const [open, setOpen] = useState(false);
  const [close, setclose] = useState(true);
  const [pasoII, setPasoII] = useState(false);
  const [pasoIII, setPasoIII] = useState(false);
  const [orden, setOrden] = useState();
  const [observaciones, setObservaciones] = useState("");

  // --- Estados para la fecha de entrega ---
  // const [fechaEntrega, setFechaEntrega] = useState(); // Estado original para la respuesta completa de la API. Lo renombramos.
  const [datosFechaOriginalAPI, setDatosFechaOriginalAPI] = useState(null); // Almacena la respuesta completa de la API de fechas
  const [fechaEntregaSeleccionada, setFechaEntregaSeleccionada] =
    useState(null); // Objeto: { texto: String, fecha: String }
  const [opcionesFechaEntrega, setOpcionesFechaEntrega] = useState([]); // Array de objetos: { texto: String, fecha: String }
  // --- Fin estados para la fecha de entrega ---

  const [descuentoIndicePromocional, setDescuentoIndicePromocional] =
    useState(0);
  const [valorDesc, setValorDesc] = useState();
  const [porcentajeDesc, setPorcentajeDesc] = useState();
  const [metodo, setMetodo] = useState("CT");
  const [error, setError] = useState();
  const [errorMessage, setErrorMessage] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [load, setLoad] = useState(false);

  let user = JSON.parse(auth.getUsuario());
  let _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {};
  let _carritoPromos =
    JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};

  const { totalAmount, iva, ico, ibua, icui, icl, adv } = useCounter();

  const getImpuestos = () => {
    return (
      (iva ?? 0) +
      (ico ?? 0) +
      (ibua ?? 0) +
      (icui ?? 0) +
      (icl ?? 0) +
      (adv ?? 0)
    );
  };

  const steepIII = () => {
    setCanTakeOrder(true);
    setPasoII(false);
    setPasoIII(true);
  };
  const steepII = () => {
    setCanTakeOrder(true);
    setPasoII(true);
  };

  const sendEncabezado = () => {
    setError(); // Limpiar errores previos

    // --- INICIO: Validación de fecha de entrega seleccionada ---
    if (!fechaEntregaSeleccionada || !fechaEntregaSeleccionada.fecha) {
      setLoad(false); // Detener cualquier loader
      setError("Fecha de entrega no seleccionada o inválida."); // Mensaje de error interno
      setErrorMessage({
        titulo: "Error en Pedido",
        descripcion: `<p style="margin: auto 0; margin-top:5%; font-size:23px; font-weight:bold"><span>Debe seleccionar una fecha de entrega válida para continuar.</span></p>`,
      });
      setShowModal(true); // Mostrar modal de notificación al usuario
      setCanTakeOrder(true); // Permitir al usuario corregir y reintentar
      return; // Detener la ejecución
    }
    // --- FIN: Validación de fecha de entrega seleccionada ---

    setCanTakeOrder(false);
    setLoad(true);
    if (metodo) {
      let detalle = [];
      let promociones = [];

      Object.keys(_carrito).map((producto) => {
        detalle.push({
          codigoSku: _carrito[producto].codigoSku,
          cantidad: _carrito[producto].cantidad,
        });
      });

      Object.keys(_carritoPromos).map((promos) => {
        promociones.push({
          codigoSku: _carritoPromos[promos].codigoSku,
          numprom: _carritoPromos[promos].numProm,
          detallePromocion: _carritoPromos[promos].seleccionados,
        });
      });

      axios
        .post(constant.PEDIDOENCABEZADO, {
          ordenCompra: orden,
          tipoPago: metodo,
          codigoCliente: sucursal.codigo,
          planta: sucursal.agencia,
          observacion: observaciones.length ? observaciones : "",
          plataforma: "WEB",
          nit: sucursal.nit,
          correo: user.email,
          fechaEntrega: fechaEntregaSeleccionada.fecha, // Usar la fecha seleccionada
          detalle: detalle,
          promociones: promociones,
        })
        .then((response) => {
          history.push({
            pathname: "/thankyou/" + response.data.orden,
          });
        })
        .catch((err) => {
          setCanTakeOrder(true);
          setError("Algo ha salido mal..");
          setErrorMessage({
            titulo: "Algo ha salido mal",
            descripcion: `<p style="margin: auto 0; margin-top:5%; font-size:23px; font-weight:bold"><span>${
              err.response?.data?.error ||
              "Error desconocido al enviar el pedido."
            }</span></p>`,
          });
          setShowModal(true);
        })
        .finally(() => {
          setLoad(false);
        });
    } else {
      setLoad(false);
      setError("Metodo de pago requerido");
      setCanTakeOrder(true); // Permitir reintentar
    }
  };

  // Se modifica la función getFechaEntrega original para incluir la nueva lógica
  const getFechaEntrega = () => {
    if (sucursal) {
      axios
        .get(
          constant.FECHAENTREGA +
            `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}`
        )
        .then((response) => {
          const dataAPI = response.data;
          setDatosFechaOriginalAPI(dataAPI); // Guardar la respuesta original de la API

          // --- INICIO: Lógica para procesar fechas para el selector ---
          const formatearFechaParaSelector = (isoString) => {
            const fechaObj = new Date(isoString);
            const diaSemana = new Intl.DateTimeFormat("es-ES", {
              weekday: "long",
              timeZone: "UTC",
            }).format(fechaObj);
            const mes = new Intl.DateTimeFormat("es-ES", {
              month: "long",
              timeZone: "UTC",
            }).format(fechaObj);
            const diaNum = fechaObj.getUTCDate(); // Usar getUTCDate para consistencia
            const anio = fechaObj.getUTCFullYear(); // Usar getUTCFullYear para consistencia
            // Formato deseado: "Lunes, Mayo 12, 2025" (ajustar capitalización si es necesario o usar dataAPI.texto directamente para la principal)
            // El formato de dataAPI.texto es " Lunes, mayo 12, 2025" (con espacio y minúscula en mes)
            return ` ${
              diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)
            }, ${mes} ${diaNum}, ${anio}`;
          };

          // La fecha principal que viene en 'texto' y 'fecha'
          const principal = {
            texto: dataAPI.texto.trim(),
            fecha: dataAPI.fecha,
          };
          setFechaEntregaSeleccionada(principal); // Seleccionar la principal por defecto

          let opciones = [principal]; // La primera opción es siempre la principal
          const fechasYaAgregadas = new Set([principal.fecha]); // Para evitar duplicados en el selector

          // Añadir hasta 3 fechas adicionales distintas del array 'dias'
          if (dataAPI.dias && dataAPI.dias.length > 0) {
            for (const dia of dataAPI.dias) {
              if (opciones.length >= 4) {
                // Máximo 4 opciones en total: principal + 3 siguientes
                break;
              }
              if (!fechasYaAgregadas.has(dia.fechaEntrega)) {
                const textoFormateado = formatearFechaParaSelector(
                  dia.fechaEntrega
                ).trim();
                opciones.push({
                  texto: textoFormateado,
                  fecha: dia.fechaEntrega,
                });
                fechasYaAgregadas.add(dia.fechaEntrega);
              }
            }
          }
          setOpcionesFechaEntrega(opciones);
          // --- FIN: Lógica para procesar fechas para el selector ---
        })
        .catch((err) => {
          console.log(err); // Mantener el log original
          // Limpiar estados relacionados con fechas en caso de error
          setDatosFechaOriginalAPI(null);
          setFechaEntregaSeleccionada(null);
          setOpcionesFechaEntrega([]);
        });
    } else {
      // Si no hay sucursal, limpiar los estados de fecha para evitar mostrar datos obsoletos
      setDatosFechaOriginalAPI(null);
      setFechaEntregaSeleccionada(null);
      setOpcionesFechaEntrega([]);
    }
  };

  const handleClick = async (e) => {
    if (!canTakeOrder) {
      return;
    }
    await handleNextStep(e);
  };
  const handleOrden = (value) => {
    setError();
    setOrden(value);
  };

  const handleMetodo = (value) => {
    setError();
    setMetodo(value);
  };

  const updateObservaciones = (value) => {
    if (value.length <= 64) {
      setObservaciones(value);
    }
  };
  const cambiarEstado = (estado) => {
    setCanTakeOrder(estado);
  };

  const handleNextStep = async (e) => {
    if (sucursal) {
      if (e.currentTarget.classList.contains("disable") || !canTakeOrder) {
        return;
      }
      cambiarEstado(false);
      if (pasoII) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      try {
        const keysCarrito = Object.keys(carritoRedux);
        let auxDetallePedido = [];
        let avanzar = true;

        keysCarrito.map((key) => {
          const product = {
            codigoSku: carritoRedux[key].codigoSku,
            cantidad: carritoRedux[key].cantidad,
          };
          auxDetallePedido.push(product);
        });
        if (sucursal && (canTakeOrder || avanzar)) {
          await axios
            .post(constant.VALIDARPEDIDO, {
              codigoCliente: sucursal.codigo,
              planta: sucursal.agencia,
              correo: user.email,
              nit: sucursal.nit,
              detalle: auxDetallePedido,
            })
            .then(() => {
              cambiarEstado(false);
              !pasoII ? steepII() : sendEncabezado();
            })
            .catch((error) => {
              setErrorMessage({
                titulo: "Ten en cuenta",
                descripcion: `<p style="margin: auto 0; margin-top:5%; font-size:23px; font-weight:bold"><span>${
                  error.response?.data?.error || "Error al validar el pedido."
                }</span></p>`,
              });
              setShowModal(true);
              // Permitir reintentar si la validación falla
              cambiarEstado(true);
            });
        }
      } finally {
        // La lógica original de canTakeOrder parece gestionarse dentro de las promesas
        // o al inicio de la función. Para minimizar cambios, se deja como estaba.
        // Si no estamos avanzando al pasoII (es decir, solo validando para ir a steepII),
        // y la validación fue exitosa (no entró al catch), canTakeOrder debería ser true.
        // Sin embargo, steepII() lo pone a true. Y sendEncabezado() maneja su propio canTakeOrder.
        // Para ser más explícito y evitar que canTakeOrder quede en false si no se llama sendEncabezado:
        if (!pasoII) {
          // Si solo se avanzó a steepII (y no hubo error en VALIDARPEDIDO)
          cambiarEstado(true);
        }
        // Si se llamó a sendEncabezado o hubo un error, esas ramas manejan setCanTakeOrder(true)
      }
    }
  };

  const valirdarDescuento = () => {
    // Mantenida como en el original
    let detalle = [];
    let promociones = [];

    Object.keys(_carrito).map((producto) => {
      detalle.push({
        codigoSku: _carrito[producto].codigoSku,
        cantidad: _carrito[producto].cantidad,
      });
    });

    Object.keys(_carritoPromos).map((promos) => {
      promociones.push({
        codigoSku: _carritoPromos[promos].codigoSku,
        numprom: _carritoPromos[promos].numProm,
        detallePromocion: _carritoPromos[promos].seleccionados,
      });
    });

    if (sucursal) {
      axios
        .post(constant.VALIDARDESC, {
          codigoCliente: sucursal.codigo,
          planta: sucursal.agencia,
          nit: sucursal.nit,
          correo: user.email,
          detalle: detalle,
          promociones: promociones,
        })
        .then((response) => {
          let descuentoAplicado = response.data.descuento ?? 0;
          let descuentoIndice = response.data.descuentoIndicePromocional ?? 0;
          setValorDesc(descuentoAplicado + descuentoIndice);
          setDescuentoIndicePromocional(descuentoIndice);
          setPorcentajeDesc(response.data.porcentajeDesc);
        })
        .catch((err) => {
          console.log(err); // Mantener el log original
        });
    }
  };

  // Se mantiene la estructura original de los useEffect.
  // La función getFechaEntrega ha sido modificada internamente.
  useEffect(() => {
    getFechaEntrega();
    valirdarDescuento();
  }, [sucursal]); // Dependencias originales

  useEffect(() => {
    valirdarDescuento();
  }, [totalAmount, carritoPromosRedux]); // Dependencias originales

  return (
    <div className="home">
      {load && (
        <TransparentLoader
          complete={true}
          tittle="Estamos procesando tu pedido"
          message="No cargues de nuevo la página ni hagas clic atrás, en instantes será confirmado"
        />
      )}
      <CabezoteComponent
        open={open}
        setOpen={setOpen}
        tipo={false}
        categoriasGlobal={null}
        close={close}
        setclose={setclose}
        mostrarOpciones={mostrarOpciones}
        setMostrarOpciones={setMostrarOpciones}
      />
      {showModal && (
        <ModalNotificacion
          setShowModal={setShowModal}
          notificacionSelect={errorMessage}
          img={""}
        />
      )}
      {load && !showModal ? ( // Evitar que el loader tape el modal de error
        <div className="background_carga"></div>
      ) : (
        <div className="carrito-content">
          {!pasoII && !pasoIII ? <Steep1 history={history}></Steep1> : null}
          {pasoII && !pasoIII ? (
            <Second
              updateOrden={handleOrden}
              observaciones={observaciones}
              updateObservaciones={updateObservaciones}
              error={error}
            ></Second>
          ) : null}
          {pasoIII ? (
            load ? ( // Este loader podría ser redundante si el global ya cubre
              <TransparentLoader />
            ) : (
              <MetodosPago
                updateMetodo={handleMetodo}
                metodo={metodo}
                error={error}
              ></MetodosPago>
            )
          ) : null}
          <div className="checkout-1">
            <div className="content-checkout">
              <div className="titulo">
                <p>
                  Tu pedido tiene{" "}
                  <b>{Object.keys(_carrito).length + " producto(s)"}</b>
                </p>
              </div>
              <hr className="line-carrito"></hr>
              <div className="detalle-carrito primero">
                <div className="descripcion">
                  <p>Subtotal</p>
                </div>
                <div className="valor">
                  <p className="derecha">
                    {" $" +
                      new Intl.NumberFormat("de-DE", {
                        // Mantener formato original si es preferido
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                      }).format(totalAmount - getImpuestos())}
                  </p>
                </div>
              </div>
              <hr className="line-carrito"></hr>
              <div className="detalle-carrito primero">
                <div className="descripcion">
                  <p>Descuento otorgado</p>
                </div>
                <div className="valor">
                  <p className="derecha">
                    {" $" +
                      new Intl.NumberFormat("de-DE", {
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                      }).format(valorDesc ? valorDesc : 0)}
                  </p>
                </div>
              </div>
              <hr className="line-carrito"></hr>
              <div className="detalle-carrito">
                <div className="descripcion">
                  <p>Impuestos</p>
                </div>
                <div className="valor">
                  <p className="derecha">
                    {" $" +
                      new Intl.NumberFormat("de-DE", {
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                      }).format(getImpuestos())}
                  </p>
                </div>
              </div>
              <hr className="line-carrito"></hr>
              <div className="detalle-carrito total">
                <div className="descripcion_2">
                  <p>Total a pagar</p>
                </div>
                <div className="valor">
                  <p className="derecha_2">
                    {" $" +
                      new Intl.NumberFormat("de-DE", {
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                      }).format(
                        totalAmount //- descuentoIndicePromocional
                      )}
                  </p>
                </div>
              </div>
              <div className="item-carrito">
                <div className="item">
                  <div className="contenedor-item-box top">
                    {/* --- INICIO: Selector de Fecha de Entrega --- */}
                    <div
                      className="item-box"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <svg
                        width="24"
                        height="20"
                        viewBox="0 0 24 24" /* ... SVG original ... */
                      >
                        <path
                          d="M12.9128 11.6777H11.0872C10.8979 11.6851 10.7187 11.7654 10.5874 11.902C10.4561 12.0385 10.3827 12.2206 10.3827 12.4101C10.3827 12.5995 10.4561 12.7816 10.5874 12.9182C10.7187 13.0547 10.8979 13.1351 11.0872 13.1424H12.9128C13.1021 13.1351 13.2812 13.0547 13.4126 12.9182C13.5439 12.7816 13.6173 12.5995 13.6173 12.4101C13.6173 12.2206 13.5439 12.0385 13.4126 11.902C13.2812 11.7654 13.1021 11.6851 12.9128 11.6777Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M5.79195 2.55229H3.05629C2.3784 2.55316 1.72854 2.82292 1.2493 3.30236C0.770057 3.78181 0.500582 4.43179 0.5 5.10968V21.3531C0.500582 22.031 0.770057 22.6809 1.2493 23.1604C1.72854 23.6398 2.3784 23.9096 3.05629 23.9105H20.9426C21.6206 23.9096 22.2706 23.6399 22.75 23.1604C23.2294 22.681 23.4991 22.0311 23.5 21.3531V5.10968C23.4994 4.4316 23.2298 3.78145 22.7503 3.30198C22.2708 2.8225 21.6207 2.55287 20.9426 2.55229H18.207V1.64004C18.1897 1.45851 18.1053 1.28996 17.9704 1.16728C17.8355 1.04461 17.6597 0.976637 17.4774 0.976637C17.295 0.976637 17.1192 1.04461 16.9843 1.16728C16.8494 1.28996 16.7651 1.45851 16.7478 1.64004V2.54899H7.25662V1.64004C7.24928 1.45072 7.16891 1.27161 7.03237 1.14026C6.89583 1.00891 6.71374 0.935547 6.52428 0.935547C6.33483 0.935547 6.15273 1.00891 6.01619 1.14026C5.87966 1.27161 5.79929 1.45072 5.79195 1.64004V2.55229ZM22.0353 21.3531C22.035 21.6428 21.9198 21.9206 21.715 22.1254C21.5101 22.3303 21.2323 22.4455 20.9426 22.4458H3.05629C2.7671 22.4438 2.49034 22.328 2.28585 22.1235C2.08136 21.919 1.96558 21.6423 1.96357 21.3531V9.49158H22.0353V21.3531ZM6.51933 5.83706C6.71341 5.83706 6.89954 5.75996 7.03678 5.62273C7.17401 5.48549 7.25111 5.29936 7.25111 5.10528V4.01586H16.7478V5.10968C16.7551 5.29899 16.8355 5.47811 16.972 5.60946C17.1086 5.7408 17.2907 5.81417 17.4801 5.81417C17.6696 5.81417 17.8517 5.7408 17.9882 5.60946C18.1247 5.47811 18.2051 5.29899 18.2125 5.10968V4.01586H20.9481C21.238 4.01615 21.516 4.13152 21.7209 4.33662C21.9257 4.54172 22.0408 4.81977 22.0408 5.10968V8.02251H1.96357V5.10968C1.9653 4.8203 2.08094 4.54326 2.28546 4.33853C2.48998 4.1338 2.76692 4.01788 3.05629 4.01586H5.79195V5.10968C5.79224 5.30386 5.86958 5.48999 6.00699 5.6272C6.1444 5.7644 6.33065 5.84146 6.52483 5.84146L6.51933 5.83706Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M16.5629 13.141H18.3874C18.486 13.1448 18.5843 13.1287 18.6765 13.0936C18.7687 13.0585 18.8528 13.0052 18.9239 12.9368C18.995 12.8685 19.0515 12.7864 19.0902 12.6957C19.1288 12.6049 19.1487 12.5073 19.1487 12.4087C19.1487 12.31 19.1288 12.2124 19.0902 12.1217C19.0515 12.0309 18.995 11.9489 18.9239 11.8805C18.8528 11.8121 18.7687 11.7588 18.6765 11.7237C18.5843 11.6886 18.486 11.6725 18.3874 11.6763H16.5629C16.4644 11.6725 16.366 11.6886 16.2739 11.7237C16.1817 11.7588 16.0975 11.8121 16.0264 11.8805C15.9553 11.9489 15.8988 12.0309 15.8602 12.1217C15.8215 12.2124 15.8016 12.31 15.8016 12.4087C15.8016 12.5073 15.8215 12.6049 15.8602 12.6957C15.8988 12.7864 15.9553 12.8685 16.0264 12.9368C16.0975 13.0052 16.1817 13.0585 16.2739 13.0936C16.366 13.1287 16.4644 13.1448 16.5629 13.141Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M7.43708 18.9766H5.61147C5.42216 18.9839 5.24304 19.0643 5.1117 19.2008C4.98035 19.3373 4.90698 19.5194 4.90698 19.7089C4.90698 19.8984 4.98035 20.0804 5.1117 20.217C5.24304 20.3535 5.42216 20.4339 5.61147 20.4412H7.43708C7.62639 20.4339 7.80551 20.3535 7.93686 20.217C8.0682 20.0804 8.14157 19.8984 8.14157 19.7089C8.14157 19.5194 8.0682 19.3373 7.93686 19.2008C7.80551 19.0643 7.62639 18.9839 7.43708 18.9766Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M12.9128 18.9766H11.0872C10.8979 18.9839 10.7187 19.0643 10.5874 19.2008C10.4561 19.3373 10.3827 19.5194 10.3827 19.7089C10.3827 19.8984 10.4561 20.0804 10.5874 20.217C10.7187 20.3535 10.8979 20.4339 11.0872 20.4412H12.9128C13.1021 20.4339 13.2812 20.3535 13.4126 20.217C13.5439 20.0804 13.6173 19.8984 13.6173 19.7089C13.6173 19.5194 13.5439 19.3373 13.4126 19.2008C13.2812 19.0643 13.1021 18.9839 12.9128 18.9766Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M12.9128 15.3262H11.0872C10.8979 15.3335 10.7187 15.4139 10.5874 15.5504C10.4561 15.687 10.3827 15.869 10.3827 16.0585C10.3827 16.248 10.4561 16.4301 10.5874 16.5666C10.7187 16.7031 10.8979 16.7835 11.0872 16.7908H12.9128C13.1021 16.7835 13.2812 16.7031 13.4126 16.5666C13.5439 16.4301 13.6173 16.248 13.6173 16.0585C13.6173 15.869 13.5439 15.687 13.4126 15.5504C13.2812 15.4139 13.1021 15.3335 12.9128 15.3262Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M16.5629 16.7914H18.3874C18.486 16.7952 18.5843 16.7791 18.6765 16.744C18.7687 16.7089 18.8528 16.6556 18.9239 16.5872C18.995 16.5188 19.0515 16.4368 19.0902 16.3461C19.1288 16.2553 19.1487 16.1577 19.1487 16.0591C19.1487 15.9604 19.1288 15.8628 19.0902 15.772C19.0515 15.6813 18.995 15.5993 18.9239 15.5309C18.8528 15.4625 18.7687 15.4092 18.6765 15.3741C18.5843 15.339 18.486 15.3229 18.3874 15.3267H16.5629C16.4644 15.3229 16.366 15.339 16.2739 15.3741C16.1817 15.4092 16.0975 15.4625 16.0264 15.5309C15.9553 15.5993 15.8988 15.6813 15.8602 15.772C15.8215 15.8628 15.8016 15.9604 15.8016 16.0591C15.8016 16.1577 15.8215 16.2553 15.8602 16.3461C15.8988 16.4368 15.9553 16.5188 16.0264 16.5872C16.0975 16.6556 16.1817 16.7089 16.2739 16.744C16.366 16.7791 16.4644 16.7952 16.5629 16.7914Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M16.5629 20.4418H18.3874C18.486 20.4456 18.5843 20.4295 18.6765 20.3944C18.7687 20.3593 18.8528 20.306 18.9239 20.2376C18.995 20.1692 19.0515 20.0872 19.0902 19.9965C19.1288 19.9057 19.1487 19.8081 19.1487 19.7094C19.1487 19.6108 19.1288 19.5132 19.0902 19.4224C19.0515 19.3317 18.995 19.2497 18.9239 19.1813C18.8528 19.1129 18.7687 19.0596 18.6765 19.0245C18.5843 18.9894 18.486 18.9733 18.3874 18.9771H16.5629C16.4644 18.9733 16.366 18.9894 16.2739 19.0245C16.1817 19.0596 16.0975 19.1129 16.0264 19.1813C15.9553 19.2497 15.8988 19.3317 15.8602 19.4224C15.8215 19.5132 15.8016 19.6108 15.8016 19.7094C15.8016 19.8081 15.8215 19.9057 15.8602 19.9965C15.8988 20.0872 15.9553 20.1692 16.0264 20.2376C16.0975 20.306 16.1817 20.3593 16.2739 20.3944C16.366 20.4295 16.4644 20.4456 16.5629 20.4418Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M7.43708 15.3262H5.61147C5.42216 15.3335 5.24304 15.4139 5.1117 15.5504C4.98035 15.687 4.90698 15.869 4.90698 16.0585C4.90698 16.248 4.98035 16.4301 5.1117 16.5666C5.24304 16.7031 5.42216 16.7835 5.61147 16.7908H7.43708C7.62639 16.7835 7.80551 16.7031 7.93686 16.5666C8.0682 16.4301 8.14157 16.248 8.14157 16.0585C8.14157 15.869 8.0682 15.687 7.93686 15.5504C7.80551 15.4139 7.62639 15.3335 7.43708 15.3262Z"
                          fill="#0075BB"
                        />
                        <path
                          d="M7.43708 11.6777H5.61147C5.42216 11.6851 5.24304 11.7654 5.1117 11.902C4.98035 12.0385 4.90698 12.2206 4.90698 12.4101C4.90698 12.5995 4.98035 12.7816 5.1117 12.9182C5.24304 13.0547 5.42216 13.1351 5.61147 13.1424H7.43708C7.62639 13.1351 7.80551 13.0547 7.93686 12.9182C8.0682 12.7816 8.14157 12.5995 8.14157 12.4101C8.14157 12.2206 8.0682 12.0385 7.93686 11.902C7.80551 11.7654 7.62639 11.6851 7.43708 11.6777Z"
                          fill="#0075BB"
                        />
                      </svg>
                      {opcionesFechaEntrega.length > 0 &&
                      fechaEntregaSeleccionada ? (
                        <>
                          <p
                            className="retornable"
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Fecha de entrega:
                          </p>
                          <select
                            value={fechaEntregaSeleccionada.fecha}
                            onChange={(e) => {
                              const seleccionada = opcionesFechaEntrega.find(
                                (opt) => opt.fecha === e.target.value
                              );
                              if (seleccionada) {
                                setFechaEntregaSeleccionada(seleccionada);
                              }
                            }}
                            style={{
                              padding: "6px 10px",
                              fontSize: "13px", // Ligeramente más pequeño para acomodar texto largo
                              lineHeight: "1.5",
                              color: "#333", // Color de texto estándar
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              marginLeft: "5px",
                              minWidth: "220px", // Ancho mínimo para mejor visualización
                              flexGrow: 1, // Para que ocupe el espacio si es necesario
                            }}
                          >
                            {opcionesFechaEntrega.map((opcion) => (
                              <option key={opcion.fecha} value={opcion.fecha}>
                                {opcion.texto}
                              </option>
                            ))}
                          </select>
                        </>
                      ) : datosFechaOriginalAPI &&
                        datosFechaOriginalAPI.texto ? (
                        <p
                          className="retornable"
                          style={{ margin: 0, fontWeight: "bold" }}
                        >
                          Fecha de entrega: {datosFechaOriginalAPI.texto.trim()}
                        </p>
                      ) : (
                        <p
                          className="retornable"
                          style={{ margin: 0, fontWeight: "bold" }}
                        >
                          Calculando fecha de entrega...
                        </p>
                      )}
                    </div>
                    {/* --- FIN: Selector de Fecha de Entrega --- */}
                  </div>
                </div>
              </div>
              <br />
              <div className="btn-carrito">
                <div
                  className={
                    "procesar-pedido no-seleccionable " +
                    (canTakeOrder ? "" : "disable")
                  }
                  onClick={handleClick}
                >
                  <span>
                    <span style={{ marginLeft: "1rem", fontSize: "15px" }}>
                      {!pasoII ? "Realizar pedido" : "Confirmar pedido"}
                    </span>
                  </span>
                </div>
                <div
                  className={
                    "seguir-comprando no-seleccionable " +
                    (canTakeOrder ? "" : "disable")
                  }
                  onClick={() => {
                    // Asegurarse que canTakeOrder se respete aquí también
                    if (!canTakeOrder) return;
                    window.location.href = "./Catalogo/Categoria/-1/Todos";
                  }}
                >
                  <span>Continuar comprando</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Checkout;
